import { MdWarning, MdMessage, MdVideocam } from 'react-icons/md';
import { IoLogoTwitter } from 'react-icons/io';
import { BsShareFill } from 'react-icons/bs';
import MessagesList from '../pages/carousels/MessagesList';

export const antenneConfig = {
  title: 'Antenne',
  columns: {
    headers: [
      { content: '', id: 1 },
      { content: '', id: 2 },
      { content: 'Nb', id: 5 },
      { content: 'Contenu', id: 4 },
      { content: '', id: 7 }
    ],
  },
  list: MessagesList,
};

export const messagesOfflineConfig = {
  title: 'Liste des messages',
  columns: {
    headers: [
      // { content: 'Type', id: 1 },
      { content: 'Contenu', id: 1 },
    ],
  },
  list: MessagesList,
};

export const icons = [
  {
    templateLabel: 'normal',
    icon: MdMessage,
    color: 'white',
  },
  {
    templateLabel: 'urgent',
    icon: MdWarning,
    color: 'var(--breaking)',
  },
  {
    templateLabel: 'promo push',
    icon: BsShareFill,
    color: 'var(--reseau)',
  },
  {
    templateLabel: 'promo',
    icon: BsShareFill,
    color: 'var(--reseau)',
  },
  {
    templateLabel: 'vod',
    icon: MdVideocam,
    color: 'white',
  },
  {
    templateLabel: 'twitter',
    icon: IoLogoTwitter,
    color: 'var(--reseau)',
  },
];

export const languageColor = [
  {
    langueID: 3,
    color: '#347be3',
  },
  {
    langueID: 2,
    color: '#9c49b0',
  },
  {
    langueID: 1,
    color: '#CEA304',
  },
  {
    langueID: 4,
    color: '#dd6710',
  },
];
